/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
    Button,
    Input,
    PasswordInput,
} from '@ya.praktikum/react-developer-burger-ui-components';
import * as auth from '../services/thunks';
import { useDispatch, useSelector, RootState } from '../services/store';
import styles from './pages.module.css';
import { TUser, TIngredientType, WebsocketStatus } from '../utils/types';
import { WS_USER_URL } from '../utils/constants';
import {
    connect as wsConnect,
    disconnect as wsDisconnect,
} from '../services/wsUser/actions';
import OrderHistoryCard from '../components/order-history-card/order-history-card';

function Profile({ orders }: { orders?: boolean }): JSX.Element {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const user = useSelector<TUser | null>((store) => store.auth.user);
    // const accessToken = useSelector((store) => store.auth.accessToken);
    const { accessToken } = localStorage;
    const all = useSelector((store: RootState) => store.fetch.data);
    const items: { [id: string]: TIngredientType } = {};
    if (orders && all) {
        all.forEach((item) => {
            items[item._id] = item;
        });
        // console.log(items);
    }
    const { data, status } = useSelector((s) => s.socketUser);
    const isConnected = status !== WebsocketStatus.OFFLINE;

    useEffect(() => {
        if (orders && !isConnected)
            dispatch(wsConnect(`${WS_USER_URL}?token=${accessToken}`));
        return () => dispatch(wsDisconnect());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orders]);

    const [form, setForm] = useState({
        name: user?.name,
        email: user?.email,
        password: user?.password,
    });

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        dispatch(auth.patchUser({ name: form.name }));
    };
    // const onChange = (field, event) => {
    //    dispatch(setUser({ ...user, [field]: event.target.value }));
    // };

    return (
        <div className={styles.profileBlock}>
            <div className={styles.leftBlock}>
                <div className="text text_type_main-medium pt-4 pb-4">
                    <Link
                        to="/profile"
                        className={orders ? styles.link_inactive : styles.link}
                    >
                        Профиль
                    </Link>
                </div>
                <div className="text text_type_main-medium text_color_inactive pt-4 pb-4">
                    <Link
                        to="/profile/orders"
                        className={orders ? styles.link : styles.link_inactive}
                    >
                        История заказов
                    </Link>
                </div>
                <div className="text text_type_main-medium text_color_inactive pt-4 pb-4">
                    {/* <NavLink to="/logout" className={styles.link_inactive}>
                        Выход
                    </NavLink> */}
                    <a
                        href="#top"
                        className={styles.link_inactive}
                        onClick={() => dispatch(auth.getLogout())}
                    >
                        Выход
                    </a>
                </div>
                {orders ? (
                    <div className="text text_type_main-default text_color_inactive mt-20">
                        В этом разделе вы можете просмотреть свою историю
                        заказов
                    </div>
                ) : (
                    <div className="text text_type_main-default text_color_inactive mt-20">
                        В этом разделе вы сможете изменить свои персональные
                        данные
                    </div>
                )}
            </div>
            {orders ? (
                <div className={`${styles.feed_profile} pt-10`}>
                    <div className={styles.feed_header}>
                        <div
                            className={`${styles.feed_block} text text_type_main-normal`}
                        >
                            {isConnected &&
                                all &&
                                data &&
                                data
                                    .slice()
                                    .reverse()
                                    .map((order) => (
                                        <OrderHistoryCard
                                            wsOrder={order}
                                            items={items}
                                            status
                                            onClick={() =>
                                                navigate(
                                                    `/profile/orders/${order.number}`,
                                                    {
                                                        state: {
                                                            background:
                                                                location,
                                                        },
                                                    }
                                                )
                                            }
                                        />
                                    ))}
                        </div>
                    </div>
                </div>
            ) : (
                <form onSubmit={onSubmit} className={styles.form}>
                    <div className="ml-15 mr-15">
                        <Input
                            placeholder="Имя"
                            extraClass="p-3"
                            value={form.name as string}
                            onChange={(e) =>
                                setForm({ ...form, name: e.target.value })
                            }
                        />
                        <Input
                            placeholder="Логин"
                            extraClass="p-3"
                            value={form.email as string}
                            onChange={(e) =>
                                setForm({ ...form, email: e.target.value })
                            }
                        />
                        <PasswordInput
                            placeholder="Пароль"
                            extraClass="p-3"
                            value={
                                form.password ? form.password : ('' as string)
                            }
                            onChange={(e) =>
                                setForm({ ...form, password: e.target.value })
                            }
                        />
                        <div className={styles.buttons}>
                            <Button htmlType="reset" type="secondary">
                                Отменить
                            </Button>
                            <Button htmlType="submit" extraClass="mr-3">
                                Сохранить
                            </Button>
                        </div>
                    </div>
                </form>
            )}
            <div className={styles.leftBlock} />
        </div>
    );
}
Profile.propTypes = {
    orders: PropTypes.bool,
};
Profile.defaultProps = {
    orders: false,
};
export default Profile;
